import { Sidebar, Menu, MenuItem, Logo } from "react-mui-sidebar";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Grid from "@mui/material/Grid2";
import Link from "@mui/material/Link";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";

export default function Homepage() {
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
        }}
      >
        <img src="/images/landing_steps.jpg" alt="" width="1152" height="700" />
      </Paper>

      <Paper
        elevation={0}
        sx={{
          width: "100%",
        }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography
              variant="h6"
              align="justify"
              sx={{
                my: "10px",
                fontWeight: 1000,
                textDecoration: "underline",
              }}
            >
              Important Notice to Client
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Typography variant="body2" align="justify">
              Meridian Global Advisory Pte Ltd (MGA) is regulated by the
              Monetary Authority of Singapore and is a licensed Financial
              Adviser under the Financial Advisers Act (Chapter 110) and an
              exempt insurance broker under the Insurance Act (Chapter 142).
              PIAS is wholly owned by Singapore Life Ltd. (“Singlife”).
              Recommendations provided to you may include insurance or
              investment products from Singapore Life Holdings Pte. Ltd. We work
              with various product providers. For more details, please visit{" "}
              <Link href="https://www.proinvest.com.sg/our-services/our-partners">
                https://www.proinvest.com.sg/our-services/our-partners
              </Link>
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                my: "10px",
              }}
            >
              The purpose of this Financial Needs Analysis (FNA) is to allow
              your Representative to (i) identify your needs through a
              fact-finding process, (ii) analyse these needs using the FNA and
              (iii) recommend suitable products to you. In order to make
              suitable recommendation your Representative requires sufficient
              information from you; including your financial situation,
              investment objectives and any other specific needs you may have.
              Your Representative must have a reasonable basis for the
              recommendation(s) they make to you. Purchasing a product without
              completing the questions in the FNA, or based on incomplete
              information, may affect the suitability of any recommendation(s).
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              PIAS is authorised to conduct the following regulated activities
              under the Financial Advisers Act:
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              <ol type="a">
                <li>
                  advising others, either directly or through publications or
                  writings, and whether in electronic, print or other form,
                  other than advising on corporate finance within the meaning of
                  the Securities and Futures Act (Chapter 289), concerning life
                  policies, securities and units in a collective investment
                  scheme;
                </li>
                <li>
                  advising others by issuing or promulgating research analyses
                  or research reports, whether in electronic, print or other
                  form, concerning life policies, securities and units in a
                  collective investment scheme; and{" "}
                </li>
                <li>
                  arranging of any contract of insurance in respect of life
                  policies, other than a contract of reinsurance.
                </li>
              </ol>
              The information that you provide in the FNA relating to your
              investment objectives, financial situation and any other specific
              needs will be the basis on which recommendation will be made. It
              is important to note your Representative’s recommendations may not
              be appropriate for you in the event of any incomplete or
              inaccurate information provided during the Know Your Client
              process.
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                my: "10px",
              }}
            >
              Service Quality Checks
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              Please be informed that PIAS Corporate Office may, at random,
              contact clients (phone or postal) to assess the quality of
              financial advisory services provided by the Representative. You
              are strongly encouraged to participate in the client surveys.{" "}
              <br />
              <br />
              If you have any feedback or concerns, you may contact your
              Representative or our main line at +65 6372 5700 or email at
              pias.compliance@singlife.com. For independent help to conclude a
              dispute, you may contact the Financial Industry Dispute Resolution
              Centre. For more information, please see www.FIDReC.com.sg
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                my: "10px",
              }}
            >
              Fees and Comissions
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              We may receive fees and commissions from our product providers for
              marketing and selling their products to you. We may share these
              fees or commission with our Representatives.
            </Typography>

            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                my: "10px",
              }}
            >
              Remuneration
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              A select group of Representatives may have received or will be
              paid transitional allowances as a form of compensation paid to
              some industry-experienced Representatives who opt for a career
              switch to join PIAS (“Transitional Allowance Scheme”); or a
              monthly allowance which is payable on a monthly basis under the
              Financial Consultant Programme (FCP)/Professional Entrepreneur
              Programme (PEP). The terms of payment are determined in accordance
              with the Representative’s contribution to the annual premium
              equivalent of life insurance products manufactured by Singapore
              Life Ltd.
              <br />
              <br />
              If your Representative is receiving such allowance from PIAS, they
              will inform you via a statement stated in the Basis of
              Recommendation of the FNA.
            </Typography>

            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                my: "10px",
              }}
            >
              Prevailing CPF Rates
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              If you are using your Central Provident Fund (CPF) monies to
              purchase an investment product, the prevailing CPF interest rates
              are at a minimum 2.5% per annum for CPF Ordinary Account (OA) and
              a minimum 4% per annum for CPF Special Account (SA) and Retirement
              Account (RA).
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                my: "10px",
              }}
            >
              Cancellation
            </Typography>
            <Typography
              variant="body2"
              align="justify"
              sx={{
                my: "10px",
              }}
            >
              You are entitled to a 7-day cancellation period for purchase of
              Collective Investment Schemes and a 14-day free-look period for
              life policies. The risk of fall in value of the underlying
              investment may have to be borne by you.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Paper>

      <Grid size={12}>
        <Stack
          direction="row"
          spacing={3}
          //divider={<Divider orientation="vertical" flexItem />}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            href="/application/personalinfo"
            sx={{ width: "200px" }}
            disabled={false}
          >
            New Application
          </Button>

          <Button variant="contained" sx={{ width: "200px" }} disabled={false}>
            Existing Application
          </Button>
        </Stack>
      </Grid>
    </>
  );
}
